import { TablesEnum } from "Shared/store/reducers/tableConfigReducer"
import { DocumentChangeInterface, OperationTypeEnum, Transaction } from "@finway-group/shared/lib/models"
import store from "Shared/store"
import { syncTransaction } from "Shared/store/actions/transaction/transactionActions"
import { refetchTable } from "Shared/store/actions/tables/tableActions"
import { setShouldFetchCashFlowsData } from "Shared/store/actions/liquidity/liquidityActions"

const subscribeToTransactions = async (dispatch: any, data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    switch (operationType) {
        case OperationTypeEnum.INSERT:
        case OperationTypeEnum.DELETE:
        case OperationTypeEnum.BULK_UPDATE:
        case OperationTypeEnum.UPDATE:
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
            dispatch(refetchTable(TablesEnum.EXPENSE_TRANSACTIONS))
            dispatch(refetchTable(TablesEnum.CARD_TRANSACTIONS))

            if (operationType === OperationTypeEnum.BULK_UPDATE || operationType === OperationTypeEnum.UPDATE) {
                // TODO: V check should we add here || operationType === case OperationTypeEnum.DELETE?
                // Perform sync to the currently opened transaction
                const currentTransactionItem = store.getState().transactions.item?.id
                if (currentTransactionItem) dispatch(syncTransaction(currentTransactionItem))
            }
            break
        case OperationTypeEnum.TRANSACTION_UPDATE_CATEGORY:
            setShouldFetchCashFlowsData(true)(dispatch)
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
            break
        default:
            break
    }
}

export const subscribeToTransactionsCallbacks = (dispatch: any, { fullDocument: { operationType } }: DocumentChangeInterface) => {
    switch (operationType) {
        case OperationTypeEnum.BULK_UPDATE:
        case OperationTypeEnum.BULK_INSERT:
            // Required to update transaction view when a category has been successful deleted when checkAndNotify returns false
            // Perform sync to the transactions
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
            // Perform sync to the currently opened transaction
            if (operationType === OperationTypeEnum.BULK_UPDATE) {
                const currentTransactionItem = store.getState().transactions.item?.id
                if (currentTransactionItem) dispatch(syncTransaction(currentTransactionItem))
            }
            break
        default:
            break
    }
}

export default subscribeToTransactions
